export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15168.0a32b54c.jpg";